// Shared trigger styling for honesty marks. Kept in one place so all four
// badges + the dot stay visually identical across every surface (SIM-015:
// "used identically on every surface").

/** Base chip: small inline mark, ≤4px radius, hairline-scale weight. */
export const CHIP_BASE =
  'inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-xs font-medium leading-none transition-colors align-baseline'

/** The dot trigger keeps a ~24px tap target around a 12px visible dot. */
export const DOT_TRIGGER =
  'inline-flex items-center justify-center rounded-full p-1 -m-1 transition-colors hover:bg-accent-soft align-middle'
